import React from 'react'
import Hero from './Hero'
import Owner from './Owner'
import AboutCom from './AboutCom'
import Comport from './Comport'
import TeamMeet from './TeamMeet'
import Insights from './Insights'
import NewsLetter from './NewsLetter'
import Faqs from './Faqs'


const Home = () => {
  return (
    <>    
    <Hero/>
    <AboutCom/>
    <Comport/>
    <Owner/>
    <TeamMeet/>
    <Insights/>
    <Faqs/>
    <NewsLetter/>
    </>
    
  )
}

export default Home